import styled, { css } from 'styled-components';
import { HEX, RGB } from '../../Styles/LegacyColors/index.js';
import { commonResets } from '../../Styles/Utils/commonResets.js';

// TO DO: Align and extract these to theme. (WP-254)
// TO DO: Extract styles from _commonStyles to packages/styles (WP-255)
const FormCheckboxWrapper = styled.label.withConfig({
    displayName: "FormCheckbox.styles__FormCheckboxWrapper",
    componentId: "sc-1e4300f1-0"
})`
    ${commonResets}
    & *,
    &:before,
    &:after,
    & *:before,
    & *:after {
        ${commonResets}
    }

    width: 100%;
    height: 100%;
    display: block;

    input[type='checkbox'] {
        width: 0;
    }

    ${(props)=>props.autoHeight && css`
            height: auto;
        `}
`;
const FormCheckboxBox = styled.div.withConfig({
    displayName: "FormCheckbox.styles__FormCheckboxBox",
    componentId: "sc-1e4300f1-1"
})`
    display: flex;
    position: relative;
    border: 1px solid ${HEX.lightGrey};
    transition: all 0.2s ease;
    cursor: pointer;
    min-height: 60px;
    padding: 15px 20px 15px 60px;

    ${(props)=>props.active && css`
            border-color: ${HEX.blue};
        `}

    ${FormCheckboxWrapper}:hover & {
        background: rgba(${RGB.blue}, 0.05);
    }
`;
const FormCheckboxDot = styled.div.withConfig({
    displayName: "FormCheckbox.styles__FormCheckboxDot",
    componentId: "sc-1e4300f1-2"
})`
    width: 20px;
    height: 20px;
    border: 1px solid ${HEX.lightGrey};
    transition: all 0.2s ease;
    position: absolute;
    top: 50%;
    margin-top: -10px;
    left: 20px;
    border-radius: 2px;

    &:after {
        width: 20px;
        height: 20px;
        transition: all 0.2s ease;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        content: ' ';
        position: absolute;
        z-index: -1;
        display: block;
        background: rgba(${RGB.blue}, 0.1);
        border-radius: 2px;
        opacity: 0;
    }

    ${(props)=>props.active && css`
            border-color: ${HEX.blue};
            background: ${HEX.blue};

            &:after {
                width: 30px;
                height: 30px;
                opacity: 1;
            }
        `}
`;
const FormCheckboxLabel = styled.div.withConfig({
    displayName: "FormCheckbox.styles__FormCheckboxLabel",
    componentId: "sc-1e4300f1-3"
})`
    font-size: 16px;
    line-height: 1.35;
    font-weight: 300;
    align-self: center;
    cursor: pointer;
`;

export { FormCheckboxBox, FormCheckboxDot, FormCheckboxLabel, FormCheckboxWrapper };
